<template>
  <div>
    <ul :id="elementId" class="context-menu" v-click-outside="onClickOutside">
      <li
        v-for="(option, index) in options"
        :key="index"
        @click.stop="optionClicked($event,option)"
        class="context-menu__item"
        :class="[option.class, option.type === 'divider' ? 'context-menu__divider' : '']"
      >
        <span v-html="option.name" />
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'AppContextMenu',
  props: {
    elementId: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: ['menu-closed', 'option-clicked'],
  data() {
    return {
      item: null,
      menuHeight: null,
      menuWidth: null,
    };
  },
  methods: {
    showMenu(event, item) {
      this.item = item;

      const menu = document.getElementById(this.elementId);
      if (!menu) {
        return;
      }

      if (!this.menuWidth || !this.menuHeight) {
        menu.style.visibility = 'hidden';
        menu.style.display = 'block';
        this.menuWidth = menu.offsetWidth;
        this.menuHeight = menu.offsetHeight;
        menu.removeAttribute('style');
      }

      if (this.menuWidth + event.pageX >= window.innerWidth) {
        menu.style.left = `${event.pageX - (this.menuWidth + 2)}px`;
      } else {
        menu.style.left = `${event.pageX - 2}px`;
      }

      if (this.menuHeight + event.pageY >= window.innerHeight) {
        menu.style.top = `${event.pageY - (this.menuHeight + 2)}px`;
      } else {
        menu.style.top = `${event.pageY - 2}px`;
      }

      menu.classList.add('context-menu--active');
    },
    hideContextMenu() {
      const element = document.getElementById(this.elementId);
      if (element) {
        element.classList.remove('context-menu--active');
        this.$emit('menu-closed');
      }
    },
    onClickOutside() {
      this.hideContextMenu();
    },
    optionClicked($event, option) {
      $event.preventDefault();
      $event.stopPropagation();
      this.hideContextMenu();
      this.$emit('option-clicked', {
        item: this.item,
        option,
      });
    },
    onEscKeyRelease(event) {
      if (event.keyCode === 27) {
        this.hideContextMenu();
      }
    },
  },
  mounted() {
    document.body.addEventListener('keyup', this.onEscKeyRelease);
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.onEscKeyRelease);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/app-context-menu/index.vue